import { Fichier } from '../../../common/src/entities';
import config from './config';

const getImageUrl = (file: Fichier | number): string => {
    let id = file;
    if (typeof file == 'object') {
        if (file.base64) return file.base64;
        id = file.id;
    }
    return config.API_URL + '/fichiers/afficher/' + id;
};
export const getImagePrincipaleUrl = (file: Fichier | number): string => {
    let id = file;
    if (typeof file == 'object') {
        if (file.base64) return file.base64;
        id = file.id;
    }
    return config.API_URL + '/fichiers/afficherImagePrincipale/' + id;
};

export const getThumbnailsImageUrl = (file: Fichier | number): string => {
    let id = file;
    if (typeof file == 'object') {
        if (file.base64) return file.base64;
        id = file.id;
    }
    return config.API_URL + '/fichiers/afficherThumbnails/' + id;
};
export const getImagePDFUrl = (file: Fichier | number): string => {
    let id = file;
    if (typeof file == 'object') {
        if (file.base64) return file.base64;
        id = file.id;
    }
    return config.API_URL + '/fichiers/afficherImagePDF/' + id;
};

export const getImageModalUrl = (file: Fichier | number): string => {
    let id = file;
    if (typeof file == 'object') {
        if (file.base64) return file.base64;
        id = file.id;
    }
    return config.API_URL + '/fichiers/afficherImageModal/' + id;
};

export default getImageUrl;
